module.exports = "/_next/static/images/40cc9c2b6a0b0164eeb1165b5104a2e0-ppf-lg.png.webp";